module.exports = __webpack_public_path__ + "img/InicioHion-xs.5200f6f2.jpg";